import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useApiContext } from '@internal/components/common/api-context';

export const useRefetchOnReturn = (enabled: boolean): void => {
  const queryClient = useQueryClient();
  const { profile } = useApiContext();
  const apiKey = profile?.apiKey ?? '';

  useEffect(() => {
    if (!enabled || !apiKey) return undefined;

    const refetch = () => {
      if (document.visibilityState !== 'visible') return;
      queryClient
        .invalidateQueries({ queryKey: ['candidate-roles', apiKey] })
        .catch(() => {});
      queryClient.invalidateQueries({ queryKey: ['profile'] }).catch(() => {});
    };

    refetch();
    window.addEventListener('focus', refetch);
    document.addEventListener('visibilitychange', refetch);
    return () => {
      window.removeEventListener('focus', refetch);
      document.removeEventListener('visibilitychange', refetch);
    };
  }, [enabled, apiKey, queryClient]);
};
